import { text as moduleText } from './text';

export const text = {
  createErrorMessage(_error: unknown): string {
    return moduleText.createError;
  },

  renameErrorMessage(_error: unknown): string {
    return moduleText.renameError;
  },

  deleteErrorMessage(_error: unknown): string {
    return moduleText.deleteError;
  },

  duplicateErrorMessage(_error: unknown): string {
    return moduleText.duplicateError;
  },
};
